module.exports = __webpack_public_path__ + "static/media/guide.107610dc.pdf";